import React from "react";

import { Link } from "react-router-dom";

const PageAction = ({ action }) => {
  return (
    <>
      <div className="col-sm-8">
        <div className="title-action">
          <Link to={action.link} className="btn btn-success">
            {action.titulo}
          </Link>
        </div>
      </div>
    </>
  );
};

export default PageAction;
